import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { CssBaseline, Box, CircularProgress } from '@mui/material';

// Pages (Lazy)
const Home = lazy(() => import('./pages/Home'));
const LandingDemoliciones = lazy(() => import('./pages/LandingDemoliciones'));
const LandingExcavaciones = lazy(() => import('./pages/LandingExcavaciones'));

const Loading = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', bgcolor: '#1a1a1a' }}>
    <CircularProgress sx={{ color: '#d4af37' }} />
  </Box>
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/demoliciones" element={<LandingDemoliciones />} />
            <Route path="/excavaciones" element={<LandingExcavaciones />} />
          </Routes>
        </Suspense>
      </Router>
    </ThemeProvider>
  );
}

export default App;